// @flow

import * as React from 'react';
import Duration from 'app/components/shared/Duration';
import FriendlyTime from 'app/components/shared/FriendlyTime';
import './styles.css';

function Label(props: { children: React.Node }) {
  return (
    <span className="semi-bold" data-testid="JobEventLabel">
      {props.children}
    </span>
  );
}

function Content(props: { children: React.Node }) {
  return (
    <div className="mt2" data-testid="JobEventContent">
      {props.children}
    </div>
  );
}

function Description(props: { children: React.Node }) {
  return (
    <p className="dark-gray small" data-testid="JobEventDescription">
      {props.children}
    </p>
  );
}

type LabelElement = React.Element<typeof Label>;
type ContentElement = React.Element<typeof Content>;
type DescriptionElement = React.Element<typeof Description>;

type Props = {|
  timestamp: string,
  previousTimestamp: ?string,
  children: React.ChildrenArray<LabelElement | ?ContentElement | ?DescriptionElement>
|};

export default class JobEvent extends React.Component<Props> {
  static Label = Label;
  static Description = Description;
  static Content = Content;

  render() {
    let label = null;
    let content = null;
    let description = null;

    React.Children.map(this.props.children, (child) => {
      if (!child) {
        return null;
      }

      switch (child.type) {
        case JobEvent.Label:
          label = child;
          break;
        case JobEvent.Content:
          content = child;
          break;
        case JobEvent.Description:
          description = child;
          break;
      }

      return null;
    });

    return (
      <section className="JobEvent" data-testid="JobEvent">
        <header className="flex-column">
          <div className="flex flex-auto items-center">
            <div className="flex flex-auto items-center">
              <div className="flex items-center">
                {label}
              </div>
              {this.props.previousTimestamp ? (
                <small className="ml1 dark-gray">
                  (+<Duration.Micro from={this.props.previousTimestamp} to={this.props.timestamp} tabularNumerals={true} />)
                </small>
              ) : null}
            </div>
            <div>
              <small className="dark-gray">
                <FriendlyTime value={this.props.timestamp} capitalized={true} fractionalSeconds={true} />
              </small>
            </div>
          </div>
          {description}
        </header>
        {content}
      </section>
    );
  }
}
